import { ChildrenInfoData } from "../../lib/type";

type Props = {
  data: ChildrenInfoData[];
  selectedChild: number;
  select_child: (index: number) => void;
  onDeleteChild: (index: number) => void;
};

export default function ChildrenInfoComp({
  data,
  selectedChild,
  select_child,
  onDeleteChild,
}: Props) {
  return (
    <article className="text-wrap text-[1.5rem] font-acme">
      <ul className="list-none">
        {data?.map(function (el: ChildrenInfoData, index: number) {
          return (
            <li
              key={index}
              className="flex flex-row items-center justify-between"
            >
              <div
                className={
                  selectedChild === index
                    ? "list-item cursor-pointer active"
                    : "list-item"
                }
                onClick={() => select_child(index)}
              >
                {el.child_name}
              </div>
              <div
                onClick={() => onDeleteChild(index)}
                title="Remove Child"
                className="text-xl cursor-pointer"
              >
                X
              </div>
            </li>
          );
        })}
      </ul>
    </article>
  );
}
